import React, {useState,useEffect} from "react";
import database from "../../firebase";
import img001 from "./001.png";
import img002 from "./002.png";
import img003 from "./003.png";
import img004 from "./004.png";
import img005 from "./005.png";

const db = database.firestore();
const storage = database.storage();

export default function PuzzleUser(props) {
    const [ID] = useState(props.ID);
    const [English, setEnglish] = useState(true);
    const [CurrentImgID, setCurrentImgID] = useState("");
    const [Level, setLevel] = useState("");
    const [ResetState, setResetState] = useState(true);
    const [Message, setMessage]= useState("No exclusive picture selected");
    const [image, setImage] = useState(null);
    const [progress, setProgress] = useState(0);

    const [row_, setRow] = useState(0);
    const [col_, setCol] = useState(0);
    //const [win, setWin] = useState(false);

    var img1 = new Image();
    var img2 = new Image();
    var Puzzle2D =  [];
    var Puzzle2D_ =  [];
    const [Map1, setMap1] = useState([]);
    const [Map2, setMap2] = useState([]);

    const start =(img_width, img_height, canvas_width, canvas_height, row, col, context)=>{
        context.clearRect (0,0,canvas_width,canvas_height);

        for (var i=0; i<row; i++){
            Puzzle2D[i] = [];
            Puzzle2D_[i] = [];

            for (var j=0; j<col; j++){
                var P_X_diff = Math.trunc(canvas_width/col);
                var P_Y_diff = Math.trunc(canvas_height/row);
                var Img_X_diff = Math.trunc(img_width/col);
                var Img_Y_diff = Math.trunc(img_height/row);

                if (i===row-1 && j===col-1){
                    var Infor = {
                        Pos_x1: P_X_diff*j+0.5,
                        Pos_y1: P_Y_diff*i+0.5,
                        Pos_xs: P_X_diff-1,
                        Pos_ys: P_Y_diff-1,
                        Pos_x2: P_X_diff*(j+1)-0.5,
                        Pos_y2: P_Y_diff*(i+1)-0.5,
    
                        Img_x1: 0,
                        Img_y1: 0,
                        Img_xs: 0,
                        Img_ys: 0,
                        Img_x2: 0,
                        Img_y2: 0,
                    }
                    var Infor_ = {
                        Pos_x1: P_X_diff*j+0.5,
                        Pos_y1: P_Y_diff*i+0.5,
                        Pos_xs: P_X_diff-1,
                        Pos_ys: P_Y_diff-1,
                        Pos_x2: P_X_diff*(j+1)-0.5,
                        Pos_y2: P_Y_diff*(i+1)-0.5,
    
                        Img_x1: 0,
                        Img_y1: 0,
                        Img_xs: 0,
                        Img_ys: 0,
                        Img_x2: 0,
                        Img_y2: 0,
                    }
                }else{
                    Infor = {
                        Pos_x1: P_X_diff*j+0.5,
                        Pos_y1: P_Y_diff*i+0.5,
                        Pos_xs: P_X_diff-1,
                        Pos_ys: P_Y_diff-1,
                        Pos_x2: P_X_diff*(j+1)-0.5,
                        Pos_y2: P_Y_diff*(i+1)-0.5,

                        Img_x1: Img_X_diff*j+0.5,
                        Img_y1: Img_Y_diff*i+0.5,
                        Img_xs: Img_X_diff-1,
                        Img_ys: Img_Y_diff-1,
                        Img_x2: Img_X_diff*(j+1)-0.5,
                        Img_y2: Img_Y_diff*(i+1)-0.5,
                    }
                    Infor_ = {
                        Pos_x1: P_X_diff*j+0.5,
                        Pos_y1: P_Y_diff*i+0.5,
                        Pos_xs: P_X_diff-1,
                        Pos_ys: P_Y_diff-1,
                        Pos_x2: P_X_diff*(j+1)-0.5,
                        Pos_y2: P_Y_diff*(i+1)-0.5,

                        Img_x1: Img_X_diff*j+0.5,
                        Img_y1: Img_Y_diff*i+0.5,
                        Img_xs: Img_X_diff-1,
                        Img_ys: Img_Y_diff-1,
                        Img_x2: Img_X_diff*(j+1)-0.5,
                        Img_y2: Img_Y_diff*(i+1)-0.5,
                    }
                }
                
                Puzzle2D[i][j] = Infor;
                Puzzle2D_[i][j] = Infor_;

                if (i===row-1 && j===col-1){
                    context.clearRect(Puzzle2D[i][j].Pos_x1, Puzzle2D[i][j].Pos_y1,
                        Puzzle2D[i][j].Pos_xs,Puzzle2D[i][j].Pos_ys) 
                    
                } else{
                    context.drawImage(img1, Puzzle2D[i][j].Img_x1, Puzzle2D[i][j].Img_y1, 
                        Puzzle2D[i][j].Img_xs, Puzzle2D[i][j].Img_ys,
                        Puzzle2D[i][j].Pos_x1, Puzzle2D[i][j].Pos_y1,  
                        Puzzle2D[i][j].Pos_xs, Puzzle2D[i][j].Pos_ys)
                }
            }
        }

    }

    const handleSwith =(p1_i, p1_j, p2_i, p2_j, context)=>{
        var Temp = {
            Img_x1: Puzzle2D[p1_i][p1_j].Img_x1,
            Img_y1: Puzzle2D[p1_i][p1_j].Img_y1,
            Img_xs: Puzzle2D[p1_i][p1_j].Img_xs,
            Img_ys: Puzzle2D[p1_i][p1_j].Img_ys,
            Img_x2: Puzzle2D[p1_i][p1_j].Img_x2,
            Img_y2: Puzzle2D[p1_i][p1_j].Img_y2,
        };
        var Temp2 = {
            Img_x1: Puzzle2D[p2_i][p2_j].Img_x1,
            Img_y1: Puzzle2D[p2_i][p2_j].Img_y1,
            Img_xs: Puzzle2D[p2_i][p2_j].Img_xs,
            Img_ys: Puzzle2D[p2_i][p2_j].Img_ys,
            Img_x2: Puzzle2D[p2_i][p2_j].Img_x2,
            Img_y2: Puzzle2D[p2_i][p2_j].Img_y2,
        };
    
        Puzzle2D[p1_i][p1_j].Img_x1 = Temp2.Img_x1;
        Puzzle2D[p1_i][p1_j].Img_y1 = Temp2.Img_y1;
        Puzzle2D[p1_i][p1_j].Img_xs = Temp2.Img_xs;
        Puzzle2D[p1_i][p1_j].Img_ys = Temp2.Img_ys;
        Puzzle2D[p1_i][p1_j].Img_x2 = Temp2.Img_x2;
        Puzzle2D[p1_i][p1_j].Img_y2 = Temp2.Img_y2;

        Puzzle2D[p2_i][p2_j].Img_x1 = Temp.Img_x1;
        Puzzle2D[p2_i][p2_j].Img_y1 = Temp.Img_y1;
        Puzzle2D[p2_i][p2_j].Img_xs = Temp.Img_xs;
        Puzzle2D[p2_i][p2_j].Img_ys = Temp.Img_ys;
        Puzzle2D[p2_i][p2_j].Img_x2 = Temp.Img_x2;
        Puzzle2D[p2_i][p2_j].Img_y2 = Temp.Img_y2;
        
        context.clearRect(Puzzle2D[p1_i][p1_j].Pos_x1, Puzzle2D[p1_i][p1_j].Pos_y1,
            Puzzle2D[p1_i][p1_j].Pos_xs,Puzzle2D[p1_i][p1_j].Pos_ys) 

        context.drawImage(img1, Puzzle2D[p2_i][p2_j].Img_x1, Puzzle2D[p2_i][p2_j].Img_y1, 
            Puzzle2D[p2_i][p2_j].Img_xs, Puzzle2D[p2_i][p2_j].Img_ys,
            Puzzle2D[p2_i][p2_j].Pos_x1, Puzzle2D[p2_i][p2_j].Pos_y1,  
            Puzzle2D[p2_i][p2_j].Pos_xs, Puzzle2D[p2_i][p2_j].Pos_ys)

    }
    const handleSwith_Load =(p1_i, p1_j, p2_i, p2_j, context,map1_)=>{
        var Temp = {
            Img_x1: map1_[p1_i][p1_j].Img_x1,
            Img_y1: map1_[p1_i][p1_j].Img_y1,
            Img_xs: map1_[p1_i][p1_j].Img_xs,
            Img_ys: map1_[p1_i][p1_j].Img_ys,
            Img_x2: map1_[p1_i][p1_j].Img_x2,
            Img_y2: map1_[p1_i][p1_j].Img_y2,
        };
        var Temp2 = {
            Img_x1: map1_[p2_i][p2_j].Img_x1,
            Img_y1: map1_[p2_i][p2_j].Img_y1,
            Img_xs: map1_[p2_i][p2_j].Img_xs,
            Img_ys: map1_[p2_i][p2_j].Img_ys,
            Img_x2: map1_[p2_i][p2_j].Img_x2,
            Img_y2: map1_[p2_i][p2_j].Img_y2,
        };
        
        map1_[p1_i][p1_j].Img_x1 = Temp2.Img_x1;
        map1_[p1_i][p1_j].Img_y1 = Temp2.Img_y1;
        map1_[p1_i][p1_j].Img_xs = Temp2.Img_xs;
        map1_[p1_i][p1_j].Img_ys = Temp2.Img_ys;
        map1_[p1_i][p1_j].Img_x2 = Temp2.Img_x2;
        map1_[p1_i][p1_j].Img_y2 = Temp2.Img_y2;

        map1_[p2_i][p2_j].Img_x1 = Temp.Img_x1;
        map1_[p2_i][p2_j].Img_y1 = Temp.Img_y1;
        map1_[p2_i][p2_j].Img_xs = Temp.Img_xs;
        map1_[p2_i][p2_j].Img_ys = Temp.Img_ys;
        map1_[p2_i][p2_j].Img_x2 = Temp.Img_x2;
        map1_[p2_i][p2_j].Img_y2 = Temp.Img_y2;
        setMap1(map1_);
        
        context.clearRect(map1_[p1_i][p1_j].Pos_x1, map1_[p1_i][p1_j].Pos_y1,
            map1_[p1_i][p1_j].Pos_xs,map1_[p1_i][p1_j].Pos_ys) 

        context.drawImage(img1, map1_[p2_i][p2_j].Img_x1, map1_[p2_i][p2_j].Img_y1, 
            map1_[p2_i][p2_j].Img_xs, map1_[p2_i][p2_j].Img_ys,
            map1_[p2_i][p2_j].Pos_x1, map1_[p2_i][p2_j].Pos_y1,  
            map1_[p2_i][p2_j].Pos_xs, map1_[p2_i][p2_j].Pos_ys)

    }

    const handleMove =(lx, ly, row, col, context)=>{
        for (var i=0; i<row; i++){
            for (var j=0; j<col; j++){
                if (lx>= Puzzle2D[i][j].Pos_x1 && lx<= Puzzle2D[i][j].Pos_x2 
                    && ly>= Puzzle2D[i][j].Pos_y1 && ly<= Puzzle2D[i][j].Pos_y2){//location found
                    if (i-1 >=0 && Puzzle2D[i-1][j].Img_xs===0){//switch top
                        handleSwith(i,j, i-1,j, context);
                        break;
                    }else if (i+1 <row && Puzzle2D[i+1][j].Img_xs===0){//switch bot 
                        handleSwith(i,j, i+1,j, context);
                        break;
                    }else if (j-1 >=0 && Puzzle2D[i][j-1].Img_xs===0){//switch left 
                        handleSwith(i,j, i,j-1, context);
                        break;
                    }else if (j+1 <col && Puzzle2D[i][j+1].Img_xs===0){//switch right
                        handleSwith(i,j, i,j+1, context);
                        break;
                    }
                }
            }
        }
    }
    const handleMove_Load =(lx, ly, row, col, context, map1_)=>{
        for (var i=0; i<row; i++){
            for (var j=0; j<col; j++){
                if (lx>= map1_[i][j].Pos_x1 && lx<= map1_[i][j].Pos_x2 
                    && ly>= map1_[i][j].Pos_y1 && ly<= map1_[i][j].Pos_y2){//location found
                    if (i-1 >=0 && map1_[i-1][j].Img_xs===0){//switch top
                        handleSwith_Load(i,j, i-1,j, context,map1_);
                        break;
                    }else if (i+1 <row && map1_[i+1][j].Img_xs===0){//switch bot 
                        handleSwith_Load(i,j, i+1,j, context,map1_);
                        break;
                    }else if (j-1 >=0 && map1_[i][j-1].Img_xs===0){//switch left 
                        handleSwith_Load(i,j, i,j-1, context,map1_);
                        break;
                    }else if (j+1 <col && map1_[i][j+1].Img_xs===0){//switch right
                        handleSwith_Load(i,j, i,j+1, context,map1_);
                        break;
                    }
                }
            }
        }
    }

    const setup =(canvas_width, canvas_height, row, col, context)=>{
        var current_px = Math.trunc (canvas_width - canvas_width/(col*2))
        var current_py = Math.trunc (canvas_height - canvas_height/(row*2))
        var diffx = Math.trunc (canvas_width/col)
        var diffy = Math.trunc (canvas_height/row)

        var c = 0;
        for (var i=0; i<500; i++){
            c = Math.floor((Math.random()*4)+1);
            if (c===1 && current_py-diffy > 0){ //swith top
                current_py -= diffy;
                handleMove(current_px, current_py, row, col, context)
            }else if (c===2 && current_py+diffy < canvas_height){ //swith bot
                current_py += diffy
                handleMove(current_px, current_py, row, col, context)
            }else if (c===3 && current_px-diffx > 0){ //swith left
                current_px -= diffx
                handleMove(current_px, current_py, row, col, context)
            }else if (c===4 && current_px+diffx < canvas_width){ //swith right
                current_px += diffx
                handleMove(current_px, current_py, row, col, context)
            }
        }
    }

    const checkwin =(row,col)=>{
        var win_ = true;
        for (var i=0; i<row; i++){
            for (var j=0; j<col; j++){
                if (Puzzle2D[i][j].Img_x1 !== Puzzle2D_[i][j].Img_x1){
                    win_ = false;
                    break; 
                }
            }
        }
        if (win_ === true){
            setResetState(true);
            var canvas = document.getElementById("canvas");
            if (CurrentImgID === "img1"){
                img1.src = img001;
            }else if (CurrentImgID === "img2"){
                img1.src = img002;
            }else if (CurrentImgID === "img3"){
                img1.src = img003;
            }else if (CurrentImgID === "img4"){
                img1.src = img004;
            }else if (CurrentImgID === "img5"){
                img1.src = img005;
            }
            var canvas_width = 300;
            var canvas_height = 300;
            var context=canvas.getContext("2d");
            Complete(img1.width, img1.height, canvas_width, canvas_height, row, col, context);
            canvas.onclick =()=>{}
        }   
    }

    var win=false;
    const checkwin_Load =(row,col, map1_,map2_, img)=>{
        var win_ = true;
        for (var i=0; i<row; i++){
            for (var j=0; j<col; j++){
                if (map1_[i][j].Img_x1 !== map2_[i][j].Img_x1){
                    win_ = false;
                    break; 
                }
            }
        }
        if (win_ === true){
            setResetState(true);
            var canvas = document.getElementById("canvas");
            win = true;
            if (img === "img1"){
                img1.src = img001;
            }else if (img === "img2"){
                img1.src = img002;
            }else if (img === "img3"){
                img1.src = img003;
            }else if (img === "img4"){
                img1.src = img004;
            }else if (img === "img5"){
                img1.src = img005;
            }else{
                img1.src = img;
            }
            var canvas_width = 300;
            var canvas_height = 300;
            var context=canvas.getContext("2d");
            Complete_Load (canvas_width, canvas_height, row, col, context,img1);
        }   
    }

    const Complete_Load =(canvas_width, canvas_height, row, col, context,img1)=>{
        context.clearRect (0,0,canvas_width,canvas_height);

        var Puzzle2DT=[];
        for (var i=0; i<row; i++){
            Puzzle2DT[i] = [];
            for (var j=0; j<col; j++){
                var P_X_diff = Math.trunc(canvas_width/col);
                var P_Y_diff = Math.trunc(canvas_height/row);
                var Img_X_diff = Math.trunc(img1.width/col);
                var Img_Y_diff = Math.trunc(img1.height/row);
                var Infor = {
                    Pos_x1: P_X_diff*j+0.5,
                    Pos_y1: P_Y_diff*i+0.5,
                    Pos_xs: P_X_diff-1,
                    Pos_ys: P_Y_diff-1,
                    Pos_x2: P_X_diff*(j+1)-0.5,
                    Pos_y2: P_Y_diff*(i+1)-0.5,

                    Img_x1: Img_X_diff*j+0.5,
                    Img_y1: Img_Y_diff*i+0.5,
                    Img_xs: Img_X_diff-1,
                    Img_ys: Img_Y_diff-1,
                    Img_x2: Img_X_diff*(j+1)-0.5,
                    Img_y2: Img_Y_diff*(i+1)-0.5,
                }
                Puzzle2DT[i][j] = Infor;
                context.drawImage(img1, Puzzle2DT[i][j].Img_x1, Puzzle2DT[i][j].Img_y1, 
                    Puzzle2DT[i][j].Img_xs, Puzzle2DT[i][j].Img_ys,
                    Puzzle2DT[i][j].Pos_x1, Puzzle2DT[i][j].Pos_y1,  
                    Puzzle2DT[i][j].Pos_xs, Puzzle2DT[i][j].Pos_ys)
                
            }
        }
    }

    const Complete =(img_width, img_height, canvas_width, canvas_height, row, col, context)=>{
        context.clearRect (0,0,canvas_width,canvas_height);

        for (var i=0; i<row; i++){
            Puzzle2D[i] = [];
            for (var j=0; j<col; j++){
                var P_X_diff = Math.trunc(canvas_width/col);
                var P_Y_diff = Math.trunc(canvas_height/row);
                var Img_X_diff = Math.trunc(img_width/col);
                var Img_Y_diff = Math.trunc(img_height/row);
                var Infor = {
                    Pos_x1: P_X_diff*j+0.5,
                    Pos_y1: P_Y_diff*i+0.5,
                    Pos_xs: P_X_diff-1,
                    Pos_ys: P_Y_diff-1,
                    Pos_x2: P_X_diff*(j+1)-0.5,
                    Pos_y2: P_Y_diff*(i+1)-0.5,

                    Img_x1: Img_X_diff*j+0.5,
                    Img_y1: Img_Y_diff*i+0.5,
                    Img_xs: Img_X_diff-1,
                    Img_ys: Img_Y_diff-1,
                    Img_x2: Img_X_diff*(j+1)-0.5,
                    Img_y2: Img_Y_diff*(i+1)-0.5,
                }
                Puzzle2D[i][j] = Infor;
                context.drawImage(img1, Puzzle2D[i][j].Img_x1, Puzzle2D[i][j].Img_y1, 
                    Puzzle2D[i][j].Img_xs, Puzzle2D[i][j].Img_ys,
                    Puzzle2D[i][j].Pos_x1, Puzzle2D[i][j].Pos_y1,  
                    Puzzle2D[i][j].Pos_xs, Puzzle2D[i][j].Pos_ys)
                
            }
        }
    }

    const ChangeToChinese =()=>{
        setEnglish(false);
        if (Message === "No exclusive picture selected"){
            setMessage("还未选择专属图片")
        }else if (Message === "exclusive image selected"){
            setMessage("专属图片已选择")
        }else if (Message === "image selected"){
            setMessage("已选择图片")
        }
    }

    const ChangeToEnglish =()=>{
        setEnglish(true);
        if (Message === "还未选择专属图片"){
            setMessage("No exclusive picture selected")
        }else if (Message === "专属图片已选择"){
            setMessage("exclusive image selected")
        }else if (Message === "已选择图片"){
            setMessage("image selected")
        }
    }

    const Display=(id)=>{
        if (ResetState === true){
            if ( CurrentImgID === "img1" || CurrentImgID === "img2"|| CurrentImgID === "img3" 
                || CurrentImgID === "img4" || CurrentImgID === "img5") document.getElementById(CurrentImgID).style.visibility="visible";
            document.getElementById(id).style.visibility="hidden";
            setCurrentImgID(id);

            var canvas = document.getElementById("canvas");
            var context = canvas.getContext("2d");
            context.clearRect (0,0,300,300);
            if (id === "img1"){
                img1.src = img001;
            }else if (id === "img2"){
                img1.src = img002;
            }else if (id === "img3"){
                img1.src = img003;
            }else if (id === "img4"){
                img1.src = img004;
            }else if (id === "img5"){
                img1.src = img005;
            }context.drawImage(img1,0,0,300,300);

            canvas.onclick =()=>{}

            if(Level!=="") document.getElementById(Level).style.visibility="visible";
            setLevel("");

            //Message 
            if (English === true){
                setMessage("image selected");
            }else{
                setMessage("已选择图片");
            }
        }
    }

    const SetLevel=(id)=>{
        if (Level !== "") document.getElementById(Level).style.visibility="visible";
        document.getElementById(id).style.visibility="hidden";
        setLevel(id);

        if (id === "Simple"){
            setRow(3);
            setCol(3);
        }else if (id === "Normal"){
            setRow(4);
            setCol(4);
        }else if (id === "Difficult"){
            setRow(5);
            setCol(5);
        }
    }
    
    const StartGame =()=>{
        if (Level !== "" && ResetState === true){
        setResetState(false);
        var canvas = document.getElementById("canvas");
        if (CurrentImgID === "img1"){
            img1.src = img001;
        }else if (CurrentImgID === "img2"){
            img1.src = img002;
        }else if (CurrentImgID === "img3"){
            img1.src = img003;
        }else if (CurrentImgID === "img4"){
            img1.src = img004;
        }else if (CurrentImgID === "img5"){
            img1.src = img005;
        }else{
            img1.src = CurrentImgID;
        }
        var context=canvas.getContext("2d");
        var row = row_;
        var col = col_;
        var canvas_width = 300;
        var canvas_height = 300;

            start(img1.width, img1.height, canvas_width, canvas_height, row, col, context);

            setup(canvas_width, canvas_height, row, col, context);
            setMap1(Puzzle2D);
            setMap2(Puzzle2D_);
            canvas.onclick = function (e){
                const canvasInfo = canvas.getBoundingClientRect();
                var x = e.clientX -  canvasInfo.left;
                var y = e.clientY - canvasInfo.top;
                //run 
                handleMove(x, y, row, col, context);
                setMap1(Puzzle2D);
                setMap2(Puzzle2D_);
                checkwin(row,col);
            }
        
        }
    }

    const Reset =()=>{
        var canvas = document.getElementById("canvas");
        var context = canvas.getContext("2d");
        context.clearRect (0,0,300,300);
        if (CurrentImgID === "img1"){
            img1.src = img001;
        }else if (CurrentImgID === "img2"){
            img1.src = img002;
        }else if (CurrentImgID === "img3"){
            img1.src = img003;
        }else if (CurrentImgID === "img4"){
            img1.src = img004;
        }else if (CurrentImgID === "img5"){
            img1.src = img005;
        }else{
            img1.src = CurrentImgID;
        }context.drawImage(img1,0,0,300,300);

        canvas.onclick =()=>{}

        if(Level!=="") document.getElementById(Level).style.visibility="visible";
        setLevel("");
        
        setResetState(true);
    }
      
    //choose image
    const handleEditImg =(e)=>{
        e.preventDefault();
        if (ResetState === true && e.target.files[0]){
            setImage(e.target.files[0]);
        }
    }

    const ConfirmImg =()=>{
        if (image != null && ResetState === true){
            if ( CurrentImgID === "img1" || CurrentImgID === "img2"|| CurrentImgID === "img3" 
                || CurrentImgID === "img4" || CurrentImgID === "img5") 
                document.getElementById(CurrentImgID).style.visibility="visible";

            storage.ref(ID+"/PuzzleTemp/"+ image.name).put(image).then(async()=>{
                await storage.ref(ID).child("PuzzleTemp/"+image.name).getDownloadURL()
                    .then(url=>{
                        img2.src = url;
                        setCurrentImgID(url);
                })
                var canvas = document.getElementById("canvas");
                img2.onload=function() {
                    var context=canvas.getContext("2d");
                    context.drawImage(img2, 0,0, 300,300)
                    setImage(null);
                    if (English === true){
                        setMessage("exclusive image selected");
                    }else{
                        setMessage("专属图片已选择");
                    }
                } 
            })
        }
    }

    const SaveGame =()=>{
        if (ResetState !== true){
            db.collection("users").doc(ID).collection("Game").doc("Puzzle").set({
                Image:CurrentImgID,
                level:Level,
                col:col_,
                row:row_
            })
            var i=0;
            var progress_=0;
            Promise.all(Map1.map(async()=>{
                db.collection("users").doc(ID).collection("Game").doc("Puzzle").collection("Map1").doc(i.toString()).set({
                    Collection:Map1[i],
                })
                db.collection("users").doc(ID).collection("Game").doc("Puzzle").collection("Map2").doc(i.toString()).set({
                    Collection:Map2[i],
                })
                
                progress_ += 100/Map1.length;
                setProgress(progress_);
                i++;
            }))
        } 
    }

    const LoadGame =()=>{
    if (ResetState=== true){
        db.collection("users").doc(ID).collection("Game").doc("Puzzle").get().then(function(doc){
            if (doc.data().Image !== ""){
                if ( CurrentImgID === "img1" || CurrentImgID === "img2"|| CurrentImgID === "img3" 
                || CurrentImgID === "img4" || CurrentImgID === "img5") 
                document.getElementById(CurrentImgID).style.visibility="visible";
                 if(Level!=="") document.getElementById(Level).style.visibility="visible";
            
            db.collection("users").doc(ID).collection("Game").doc("Puzzle").collection("Map1").get().then(querySnapshot=>{
                const data = querySnapshot.docs.map(doc=>doc.data());
                setCurrentImgID(doc.data().Image);
                setLevel(doc.data().level);
                setRow(doc.data().row);
                setCol(doc.data().col);

                db.collection("users").doc(ID).collection("Game").doc("Puzzle").collection("Map2").get().then(querySnapshot_=>{
                    const data_ = querySnapshot_.docs.map(doc_=>doc_.data());
                    var map1_=[]; var map2_=[]; var i=0; var progress_=0;
                    Promise.all(data.map(async()=>{
                        map1_[i]= data[i].Collection;
                        map2_[i] = data_[i].Collection;
                        progress_ += 100/data.length;
                        setProgress(progress_);
                        i++;
                    })).then(()=>{
                        setResetState(false);
                        if (doc.data().Image === "img1" || doc.data().Image === "img2" || doc.data().Image === "img3"
                        || doc.data().Image === "img4" || doc.data().Image === "img5"){
                            document.getElementById(doc.data().Image).style.visibility="hidden";
                            if (English === true){
                                setMessage("image selected");
                            }else{
                                setMessage("已选择图片");
                            }
                        }
                        document.getElementById(doc.data().level).style.visibility="hidden";
                        

                        if (doc.data().Image === "img1"){
                            img1.src = img001;
                        }else if (doc.data().Image === "img2"){
                            img1.src = img002;
                        }else if (doc.data().Image === "img3"){
                            img1.src = img003;
                        }else if (doc.data().Image === "img4"){
                            img1.src = img004;
                        }else if (doc.data().Image === "img5"){
                            img1.src = img005;
                        }else{
                            img1.src = doc.data().Image;
                            if (English === true){
                                setMessage("exclusive image selected");
                            }else{
                                setMessage("专属图片已选择");
                            }
                        }
                        //canvas
                        var canvas = document.getElementById("canvas");
                        canvas.onclick =()=>{}
                        var context=canvas.getContext("2d");
                        context.clearRect (0,0,300,300);
                        img1.onload=function() {
                            setMap1(map1_);
                            setMap2(map2_);
                            for(var i=0; i<doc.data().row; i++){
                                for (var j=0; j<doc.data().col; j++){
                                    context.drawImage(img1, map1_[i][j].Img_x1, map1_[i][j].Img_y1, 
                                        map1_[i][j].Img_xs, map1_[i][j].Img_ys,
                                        map1_[i][j].Pos_x1, map1_[i][j].Pos_y1,  
                                        map1_[i][j].Pos_xs, map1_[i][j].Pos_ys)
                                }
                            }
                            canvas.onclick = function (e){
                                if (win === true){
                                    canvas.onclick = ()=>{}
                                }else{
                                    const canvasInfo = canvas.getBoundingClientRect();
                                    var x = e.clientX -  canvasInfo.left;
                                    var y = e.clientY - canvasInfo.top;
                                    handleMove_Load(x, y, doc.data().row, doc.data().col, context, map1_);
                                    checkwin_Load( doc.data().row, doc.data().col, map1_, map2_, doc.data().Image);
                                }
                            }
                        }
                        
                    })
                })
            
            })}
        })
    }
    }

    useEffect(()=>{
        if (progress > 99.9){
            setTimeout(()=>{
                setProgress(0);
            },1200)
        }
    },[progress])


    return (
        <div>
        {English?(
            <div className="Puzzle">
                <div className="Puzzle-Title">
                    <h1>PUZZLE</h1>
                    <div onClick={ChangeToChinese}> <h3>中文</h3></div>
                </div>

                <div className="Puzzle-Choose">
                    <div className="Puzzle-Choose-Button">
                    <div id="img1" onClick={()=>{Display("img1")}}><img src={img001} alt="001" /></div>
                    <div id="img2" onClick={()=>{Display("img2")}}><img src={img002} alt="002" /></div>
                    <div id="img3" onClick={()=>{Display("img3")}}><img src={img003} alt="003" /></div>
                    <div id="img4" onClick={()=>{Display("img4")}}><img src={img004} alt="004" /></div>
                    <div id="img5" onClick={()=>{Display("img5")}}><img src={img005} alt="005" /></div>
                    </div>

                    <div className="Puzzle-Choose-Display">
                    <div><img src={img001} alt="001" /></div>
                    <div><img src={img002} alt="002" /></div>
                    <div><img src={img003} alt="003" /></div>
                    <div><img src={img004} alt="004" /></div>
                    <div><img src={img005} alt="005" /></div>
                    </div>

                    <div className="Puzzle-Choose-Img"> 
                        <input type="file" id="inputImg"  onChange={handleEditImg}/>
                        <label htmlFor="inputImg">Select Image</label>
                        <h6>{Message}</h6>
                        <button onClick={ConfirmImg}><h5>confirm</h5></button>
                    </div>

                </div>
                
                <div className="Puzzle-Control-U">
                    <div className="Puzzle-Control-Button-U">
                    <div onClick={StartGame}><h6>Start</h6></div>
                    <div onClick={Reset}><h6>Reset</h6></div>
                    </div>
                </div>

                <div className="Puzzle-Control-User">
                    <div className="Puzzle-Control-Button-User">
                    <div onClick={SaveGame}><h6>Save</h6></div>
                    <div onClick={LoadGame}><h6>Load</h6></div>
                    </div>
                    <progress value={progress} max="100"/><br/>
                </div>

                <div className="Puzzle-Level">
                    <h1>LEVEL</h1>

                    <div className="Puzzle-Level-Button">
                    <div ><h6>Simple</h6></div>
                    <div ><h6>Normal </h6></div>
                    <div ><h6>Difficult </h6></div>
                    </div>
                    
                    <div className="Puzzle-Level-Display">
                    <div id="Simple" onClick={()=>{SetLevel("Simple")}}><h6>Simple</h6></div>
                    <div id="Normal" onClick={()=>{SetLevel("Normal")}}><h6>Normal </h6></div>
                    <div id="Difficult" onClick={()=>{SetLevel("Difficult")}}><h6>Difficult </h6></div>
                    </div>
                </div>

                <div className="Puzzle-Game-User">
                    <canvas id="canvas" width="300" height="300"> A drawing of something </canvas>
                </div>

            </div>
        ):(
            <div className="Puzzle">
                <div className="Puzzle-Title">
                <h2>华容道</h2>
                <div onClick={ChangeToEnglish}> <h3>English</h3></div>
                </div>

                <div className="Puzzle-Choose">
                    <div className="Puzzle-Choose-Button">
                    <div id="img1" onClick={()=>{Display("img1")}}><img src={img001} alt="001" /></div>
                    <div id="img2" onClick={()=>{Display("img2")}}><img src={img002} alt="002" /></div>
                    <div id="img3" onClick={()=>{Display("img3")}}><img src={img003} alt="003" /></div>
                    <div id="img4" onClick={()=>{Display("img4")}}><img src={img004} alt="004" /></div>
                    <div id="img5" onClick={()=>{Display("img5")}}><img src={img005} alt="005" /></div>
                    </div>

                    <div className="Puzzle-Choose-Display">
                    <div><img src={img001} alt="001" /></div>
                    <div><img src={img002} alt="002" /></div>
                    <div><img src={img003} alt="003" /></div>
                    <div><img src={img004} alt="004" /></div>
                    <div><img src={img005} alt="005" /></div>
                    </div>

                    <div className="Puzzle-Choose-Img"> 
                        <input type="file" id="inputImg"  onChange={handleEditImg}/>
                        <label htmlFor="inputImg">选择专属图片</label>
                        <h6>{Message}</h6>
                        <button onClick={ConfirmImg}><h5>确认</h5></button>
                    </div>
                </div>
                
                <div className="Puzzle-Control-U">
                    <div className="Puzzle-Control-Button-U">
                    <div onClick={StartGame}><h6>开始</h6></div>
                    <div onClick={Reset}><h6>重置</h6></div>
                    </div>
                </div>

                <div className="Puzzle-Control-User">
                    <div className="Puzzle-Control-Button-User">
                    <div onClick={SaveGame}><h6>保存</h6></div>
                    <div onClick={LoadGame}><h6>读取</h6></div>
                    </div>
                </div>

                <div className="Puzzle-Level">
                    <h2>难度</h2>

                    <div className="Puzzle-Level-Button">
                    <div ><h6>简单</h6></div>
                    <div ><h6>普通 </h6></div>
                    <div ><h6>困难 </h6></div>
                    </div>
                    
                    <div className="Puzzle-Level-Display">
                    <div id="Simple" onClick={()=>{SetLevel("Simple")}}><h6>简单</h6></div>
                    <div id="Normal" onClick={()=>{SetLevel("Normal")}}><h6>普通 </h6></div>
                    <div id="Difficult" onClick={()=>{SetLevel("Difficult")}}><h6>困难  </h6></div>
                    </div>
                </div>

                <div className="Puzzle-Game-User">
                    <canvas id="canvas" width="300" height="300"> A drawing of something </canvas>
                </div>
            </div>
        )}
        </div>
  );
}